import { createSlice } from "@reduxjs/toolkit";
import {
  layoutTypes,
  leftSidebarTypes,
  layoutModeTypes,
  layoutWidthTypes,
  layoutPositionTypes,
  topbarThemeTypes,
  leftsidbarSizeTypes,
  leftSidebarViewTypes,
  leftSidebarImageTypes,
  preloaderTypes,
  sidebarVisibilitytypes,
  layoutTheme,
  layoutThemeColor
} from "../../Components/constants/layout";

const getInitialMode = () => {
  const savedMode = localStorage.getItem('themeMode');
  return savedMode === 'dark' ? layoutModeTypes.DARKMODE : layoutModeTypes.LIGHTMODE;
};

const getInitialLeftSidebarTheme = () => {
  const savedMode = localStorage.getItem('themeMode');
  return savedMode === 'dark' ? leftSidebarTypes.DARK : leftSidebarTypes.LIGHT;
};

export const initialState = {
  layoutType: layoutTypes.VERTICAL,
  layoutThemeType: layoutTheme.INTERACTIVE,
  layoutThemeColorType: layoutThemeColor.DEFAULT,
  leftSidebarType: getInitialLeftSidebarTheme(),
  layoutModeType: getInitialMode(),
  layoutWidthType: layoutWidthTypes.FLUID,
  layoutPositionType: layoutPositionTypes.FIXED,
  topbarThemeType: topbarThemeTypes.LIGHT,
  leftsidbarSizeType: leftsidbarSizeTypes.DEFAULT,  // SMALLICON → DEFAULT: ikon+yazı tam genişlik
  leftSidebarViewType: leftSidebarViewTypes.DEFAULT,
  leftSidebarImageType: leftSidebarImageTypes.NONE,
  preloader: preloaderTypes.DISABLE,
  sidebarVisibilitytype: sidebarVisibilitytypes.SHOW
};

const LayoutSlice = createSlice({
  name: 'LayoutSlice',
  initialState,
  reducers: {
    changeLayoutAction(state, action) {
      state.layoutType = action.payload;
    },
    changeLayoutThemeAction(state, action) {
      state.layoutThemeType = action.payload;
    },
    changeLayoutThemeColorAction(state, action) {
      state.layoutThemeColorType = action.payload;
    },
    changeLayoutModeAction(state, action) {
      state.layoutModeType = action.payload;
    },
    changeSidebarThemeAction(state, action) {
      state.leftSidebarType = action.payload;
    },
    changeLayoutWidthAction(state, action) {
      state.layoutWidthType = action.payload;
    },
    changeLayoutPositionAction(state, action) {
      state.layoutPositionType = action.payload;
    },
    changeTopbarThemeAction(state, action) {
      state.topbarThemeType = action.payload;
    },
    changeLeftsidebarSizeTypeAction(state, action) {
      state.leftsidbarSizeType = action.payload;
    },
    changeLeftsidebarViewTypeAction(state, action) {
      state.leftSidebarViewType = action.payload;
    },
    changeSidebarImageTypeAction(state, action) {
      state.leftSidebarImageType = action.payload;
    },
    changePreLoaderAction(state, action) {
      state.preloader = action.payload;
    },
    changeSidebarVisibilityAction(state, action) {
      state.sidebarVisibilitytype = action.payload;
    },
  }
});

export const {
  changeLayoutAction,
  changeLayoutModeAction,
  changeSidebarThemeAction,
  changeLayoutWidthAction,
  changeLayoutPositionAction,
  changeTopbarThemeAction,
  changeLeftsidebarSizeTypeAction,
  changeLeftsidebarViewTypeAction,
  changeSidebarImageTypeAction,
  changePreLoaderAction,
  changeSidebarVisibilityAction,
  changeLayoutThemeAction,
  changeLayoutThemeColorAction
} = LayoutSlice.actions;

export default LayoutSlice.reducer;